import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import AsignarEjecutado from "../components/Metas/AsignarEjecutadoMeta";

class Metas extends React.Component {
  initialState = {
    buscar: {},
    locations: Api.loadCatalogue("locations"),
    checkbox: false,
    nivelUsuario: localStorage.nivel_actual,
    open_modal_ejecutado: false,
    asignar_ejecutado: {
      meta_id: "",
      meta: "",
      codigo: "",
      ejecutado: "",
    },
    metas_ejecutados: [],
    ejecutados: [],
    data: {},
    workingGrid: false,
    reporte_metas: [],
    paginaActual: 0,
    paginas: 0,
    registros: 0,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.handleModal = this.handleModal.bind(this);
    this.handleChangeGeneral = this.handleChangeGeneral.bind(this);
    this.handleReportesPage = this.handleReportesPage.bind(this);

    this.handleChangeEjecutado = this.handleChangeEjecutado.bind(this);
    this.addEjecutado = this.addEjecutado.bind(this);
    this.remmoveEjecutado = this.remmoveEjecutado.bind(this);

    this.handleCloseModalE = this.handleCloseModalE.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

//  mi_grid = {};
  generar_reporte = "";
  componentDidMount() {
    // si el usuario no es nivel administrador ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "2") {
      window.location.href = "/";
    }

    this.setReportesPoaPage(1);
/*     let grid = {
      source: "app/getReportesPoa",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio",
        },
        fecha_generacion: {
          label: "Fecha generada",
          render: (me) => {
            me.innerHTML = me.data.fecha_generacion
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        fecha_inicio: {
          label: "Fecha inicio",
          render: (me) => {
            me.innerHTML = me.data.fecha_inicio
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        fecha_fin: {
          label: "Fecha final",
          render: (me) => {
            me.innerHTML = me.data.fecha_fin
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-download",
          btnClass: "btn btn-primary",
          download: "download",
          btnClick: (data) => {
            window.location.href =
              Api.url + `app/descargarReportePoa/?id=${data.id}`;
          },
          render: (me, data) => {},
        },
      ],
    };

    this.mi_grid = Api.grid(grid); */

    let busqueda = Api.form({
      target: "#busqueda",
      render: (form) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Folio",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_generada",
            label: "Fecha generada desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_generada2",
            label: "Fecha generada hasta",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_i",
            label: "Fecha inicio",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_f",
            label: "Fecha final",
            cols: 2,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: busqueda.data() });
              this.setReportesPoaPage(1);
            },
          },
        },
      ],
    });

    let formaModalGenerar = {
      target: "#generar",
      nombre: "generar",
      elementClass: "form-control",
      elements: [
        {
          select: {
            cols: 9,
            name: "departamento_id",
            label: "Departamento <span class='text-danger'>*</span>",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.locations.departamentos.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.name}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "checkbox",
            name: "general",
            label: "General",
            cols: 3,
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_inicio",
            label: "Fecha inicio <span class='text-danger'>*</span>",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_fin",
            label: "Fecha final <span class='text-danger'>*</span>",
            cols: 6,
            value: "",
          },
        },
      ],
    };

    this.generar_reporte = Api.form(formaModalGenerar);
  }

  setReportesPoaPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getReportesPoa?page=" + page + src).then((i) => {
      this.setState({
        reporte_metas: i.data,
        paginas: i.last_page,
        registros: i.total,
        paginaActual: i.current_page,
        workingGrid: false,
      });
    });
  }

  handleReportesPage(e) {
    this.setReportesPoaPage(e.target.value);
  }

  handleModal(e) {
    this.generar_reporte.clear();

    this.generar_reporte.querySelector("#general").value = false;
    this.generar_reporte
      .querySelector(".general")
      .addEventListener("change", this.handleChangeGeneral);

    Swal.fire({
      title: "Generar reporte",
      html: this.generar_reporte,
      showCancelButton: true,
      confirmButtonText: "Continuar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      preConfirm: () => {
        let dataForm = this.generar_reporte.data();
        let valido = 1;

        if (!dataForm.fecha_inicio || !dataForm.fecha_fin) {
          Swal.showValidationMessage("Favor de asignar ambas fechas.");
          valido = 0;
        }

        if (dataForm.fecha_inicio > dataForm.fecha_fin) {
          Swal.showValidationMessage("Favor de corregir la fecha de inicio.");
          valido = 0;
        }

        if (
          (!dataForm.general || dataForm.general === false) &&
          (dataForm.departamento_id === "" || !dataForm.departamento_id)
        ) {
          Swal.showValidationMessage("Favor de seleccionar el departamento.");
          valido = 0;
        }

        if (valido) {
          /**se abrira el modal para llenar los ejecutados de forma manual */
          Api.loading(true);
          Api.fetch(
            "app/getMetasAsignarEjecutados",
            {
              fecha_inicio: dataForm.fecha_inicio,
              fecha_final: dataForm.fecha_fin,
            },
            "post"
          ).then((r) => {
            Api.loading(false);

            if (r.existe_poa) {
              this.mensajeError(
                "Atención",
                "Ya existe un reporte de esas fechas."
              );
            } else {
              this.setState({
                open_modal_ejecutado: true,
                metas_ejecutados: r.metas,
                data: dataForm,
              });
            }
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  handleChangeGeneral() {
    let aux = this.state.checkbox ? false : true;

    if (aux) {
      //verdadero
      this.generar_reporte.querySelector("#general").value = aux;
      this.generar_reporte.querySelector("#departamento_id").value = "";
      this.generar_reporte.querySelector("#departamento_id").disabled = true;
    } else {
      this.generar_reporte.querySelector("#general").value = aux;
      this.generar_reporte.querySelector("#departamento_id").disabled = false;
    }

    this.setState({ checkbox: aux });
  }

  handleChangeEjecutado(e) {
    let ejecutado = { ...this.state.asignar_ejecutado };

    switch (e.target.name) {
      case "meta_id":
        let m = this.state.metas_ejecutados.find(
          (d) => d.id.toString() === e.target.value
        );

        ejecutado["meta"] = m.descripcion;
        ejecutado["codigo"] = m.codigo;
        break;
      case "ejecutado":
        let entero = /^[0-9]\d*$/;

        if (e.target.value === "" || entero.test(e.target.value)) {
          ejecutado[e.target.name] = e.target.value;
          this.setState({ asignar_ejecutado: ejecutado });
          return;
        } else {
          return;
        }
      default:
        break;
    }

    ejecutado[e.target.name] = e.target.value;
    this.setState({ asignar_ejecutado: ejecutado });
  }

  addEjecutado() {
    let ejecutado = { ...this.state.asignar_ejecutado };
    let lista_ejecutados = [...this.state.ejecutados];

    if (this.validarFormulario(ejecutado)) {
      /**validar que no este en la lista */
      for (let i in lista_ejecutados) {
        if (lista_ejecutados[i].meta_id === ejecutado.meta_id) {
          this.mensajeError(
            "Atención",
            "Ya se asignó un tiempo de ejecución a esta meta."
          );
          return false;
        }
      }

      lista_ejecutados.push(ejecutado);

      //tengo que quitar el documento del select
      let lista = [...this.state.metas_ejecutados];
      for (let i in this.state.metas_ejecutados) {
        if (lista[i].id === parseInt(ejecutado.meta_id)) {
          lista.splice(parseInt(i), 1);
          break;
        }
      }

      ejecutado = this.initialState.asignar_ejecutado; //limpio los campos
      this.setState({
        ejecutados: lista_ejecutados,
        asignar_ejecutado: ejecutado,
        metas_ejecutados: lista,
      });
    }
  }

  remmoveEjecutado(e) {
    let id = parseInt(e.target.getAttribute("data-id"));
    let codigo = e.target.getAttribute("data-codigo");
    let descripcion = e.target.getAttribute("data-descripcion");

    let lista_ejecutados = [...this.state.ejecutados];
    lista_ejecutados.splice(e.target.id, 1);

    //agregamos de nuevo en el select
    let array = [...this.state.metas_ejecutados];
    let obj_meta_ejecutada = {
      id: id,
      codigo: codigo,
      descripcion: descripcion,
    };

    array.push(obj_meta_ejecutada);
    this.setState({ metas_ejecutados: array, ejecutados: lista_ejecutados });
  }

  validarFormulario(data) {
    for (let d in data) {
      if (data[d] === "") {
        // si alguno de mis atributos esta vacio, no agrego
        this.mensajeError("Atención", "Favor de revisar los campos.");
        return 0;
      }
    }
    return 1;
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  handleCloseModalE() {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          open_modal_ejecutado: false,
          asignar_ejecutado: this.initialState.asignar_ejecutado,
          metas_ejecutados: [],
          ejecutados: [],
        });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    let ejecutados = this.state.ejecutados;
    if (this.state.metas_ejecutados.length !== 0) {
      this.mensajeError(
        "Atención",
        "Favor de asegurarse que no falte ningún ejecutado para la meta."
      );
    } else {
      Swal.fire({
        title: "¿Seguro que desea continuar?",
        showCancelButton: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/generarReportePoa",
            {
              dataForm: this.state.data,
              ejecutados: ejecutados,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: r.message,
              //text: "Se generó reporte con éxito",
            });
            this.setState({
              open_modal_ejecutado: false,
              asignar_ejecutado: this.initialState.asignar_ejecutado,
              metas_ejecutados: [],
              ejecutados: [],
            });
            this.setReportesPoaPage(1);
          });
        }
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Metas</li>
          <li className="breadcrumb-item active">
            Visualización de reportes POA
          </li>
        </ol>
        <h1 className="page-header">Visualización de reportes POA</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <fieldset>
                  <div className="form-group col-md-12">
                    <button
                      //type=""
                      onClick={this.handleModal}
                      id="generar_reporte"
                      className="btn btn-info col-md-2 float-right"
                    >
                      Generar
                    </button>
                  </div>
                </fieldset>
                {/* <div id="myGrid"></div> */}
                 {/* EMPIEZA LA TABLA */}
                 <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">NOMBRE</th>
                      <th className="text-center">FECHA GENERADA</th>
                      <th className="text-center">FECHA INICIO</th>
                      <th className="text-center">FECHA FINAL</th>
                      <th className="text-center"> </th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.reporte_metas && this.state.reporte_metas.length > 0 ? (
                      this.state.reporte_metas.map((rm) => (
                        <tr>
                          <td className="text-center">{rm.folio}</td>
                          <td className="text-center">{rm.fecha_generacion
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")}
                          </td>
                          <td className="text-center">{rm.fecha_inicio
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")}
                          </td>
                          <td className="text-center">{rm.fecha_fin
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")}
                          </td>
                          <td className="text-center">
                           <button
                              id={"button_rm_" + rm.id}
                              onClick={()=>{
                                window.location.href =
                                Api.url + `app/descargarReportePoa/?id=${rm.id}`;
                              }}
                              className="btn btn-primary"
                            >
                              <i
                                id={"i_rm_" + rm.id}
                                className="fa fa-download"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center" colSpan={5}>No hay datos</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setReportesPoaPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setReportesPoaPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setReportesPoaPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setReportesPoaPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleReportesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
                {/* TERMINA LA TABLA */}
              </div>
            </div>
          </PanelBody>
        </Panel>

        {/**Modal para Asignar */}
        <Modal
          isOpen={this.state.open_modal_ejecutado}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.handleCloseModalE();
            }}
            className="text-center"
          >
            Asignar tiempo de ejecución de forma manual según la meta
          </ModalHeader>
          <ModalBody>
            <AsignarEjecutado component={this} state={this.state} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Metas;
